/*
 * Gift with purchase prompt (26 Oct 2026, ClickUp 14ymvzwxrex).
 * Fills every .js-gift-progress line from the cart, and refreshes it each time the
 * theme refreshes its free-shipping bar (theme.freeShipping.load runs on every cart change).
 * Spend excludes the gift products and gift cards, matching the automatic discounts.
 * "Free" is read from Shopify's own discount on the gift line, never assumed.
 */
(function () {
  if (window.ddGiftProgress) return;
  window.ddGiftProgress = true;

  var END = Date.UTC(2026, 11, 24, 12, 59, 59); // 24 Dec 2026 23:59:59 AEDT
  var lastMessage = null;
  var latestSeq = 0;
  var announcer = null;

  function ids(el, name) {
    return (el.getAttribute(name) || '').split(',').filter(Boolean).map(Number);
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency || 'AUD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function link(href, text) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = text;
    return a.outerHTML;
  }

  // Thresholds are in AUD. International markets see prices without GST, so a converted
  // threshold can't be predicted reliably here; the prompt shows for AUD carts only.
  function tier(el, name) {
    return Number(el.getAttribute(name));
  }

  function summarise(cart, el) {
    var giftIds = ids(el, 'data-gift-ids');
    var excludeIds = ids(el, 'data-exclude-ids');
    var socksIds = ids(el, 'data-socks-ids');
    var bonnetIds = ids(el, 'data-bonnet-ids');
    var s = { spend: 0, socks: 0, socksFree: false, bonnet: 0, bonnetFree: false };

    (cart.items || []).forEach(function (item) {
      var id = item.product_id;
      // Free = at least one whole unit discounted to $0 (a 10% code on the line is not a free gift).
      var free = item.original_price > 0 && item.line_level_total_discount >= item.original_price;
      if (giftIds.indexOf(id) === -1 && excludeIds.indexOf(id) === -1) s.spend += item.final_line_price;
      if (socksIds.indexOf(id) !== -1) { s.socks += item.quantity; s.socksFree = s.socksFree || free; }
      if (bonnetIds.indexOf(id) !== -1) { s.bonnet += item.quantity; s.bonnetFree = s.bonnetFree || free; }
    });
    return s;
  }

  function socksLine(s, el) {
    if (s.socksFree) {
      return s.socks > 1
        ? 'One pair of Diva socks in your cart is free; the others are charged.'
        : 'Your free Diva socks are in your cart.';
    }
    if (s.socks) return 'Your Diva socks aren’t showing as free. A discount code can replace the free gift.';
    if (el.getAttribute('data-socks-available') !== 'true') return 'The free Diva socks have all gone, sorry.';
    return 'You’ve earned free Diva socks. ' + link(el.getAttribute('data-socks-url'), 'Add a pair');
  }

  function message(cart, el) {
    if (!cart || !cart.item_count || Date.now() > END) return '';
    var currency = cart.currency || 'AUD';
    if (currency !== 'AUD') return '';
    var tierSocks = tier(el, 'data-tier-socks');
    var tierBonnet = tier(el, 'data-tier-bonnet');
    var bonnetAvailable = el.getAttribute('data-bonnet-available') === 'true';
    var s = summarise(cart, el);

    if (s.spend < tierSocks) {
      return 'Spend ' + money(tierSocks - s.spend, currency) + ' more for free Diva socks.';
    }
    if (s.spend < tierBonnet || (!bonnetAvailable && !s.bonnet)) {
      var nudge = bonnetAvailable && s.spend < tierBonnet
        ? ' Spend ' + money(tierBonnet - s.spend, currency) + ' more for a free soft-ear bonnet instead.'
        : '';
      return socksLine(s, el) + nudge;
    }
    if (s.bonnetFree) {
      var extra = s.bonnet > 1 ? ' One bonnet is free; the others are charged.' : '';
      var swap = s.socks ? ' It replaces the free socks, so the socks are now charged. Remove them if you don’t want them.' : '';
      return 'Your free soft-ear bonnet is in your cart.' + extra + swap;
    }
    if (s.bonnet) return 'Your soft-ear bonnet isn’t showing as free. A discount code can replace the free gift.';
    if (s.socksFree) {
      return 'You’ve earned a free soft-ear bonnet instead of the socks. ' + link(el.getAttribute('data-bonnet-url'), 'Add yours');
    }
    return 'You’ve earned a free soft-ear bonnet. ' + link(el.getAttribute('data-bonnet-url'), 'Add yours');
  }

  // One screen-reader announcement per change, instead of one per copy of the line on the page.
  function announce(text) {
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.setAttribute('role', 'status');
      announcer.setAttribute('aria-live', 'polite');
      announcer.className = 'gift-progress-announcer';
      document.body.appendChild(announcer);
    }
    announcer.textContent = text;
  }

  function render(cart) {
    var nodes = document.querySelectorAll('.js-gift-progress');
    if (!nodes.length) return;
    var html = message(cart, nodes[0]);
    nodes.forEach(function (el) {
      if (el.innerHTML !== html) el.innerHTML = html;
      el.hidden = html === '';
    });
    var changed = lastMessage !== null && html !== lastMessage;
    lastMessage = html;
    if (changed && html) announce(nodes[0].textContent);
  }

  function refresh() {
    var seq = ++latestSeq;
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) { if (seq === latestSeq) render(cart); })
      .catch(function () {});
  }

  function hook(attempt) {
    var fs = window.theme && theme.freeShipping;
    if (fs && typeof fs.load === 'function') {
      if (!fs.ddGiftHooked) {
        var original = fs.load;
        fs.load = function (cart) {
          var result = original.apply(this, arguments);
          latestSeq++; // a cart update supersedes any fetch still in flight
          render(cart);
          return result;
        };
        fs.ddGiftHooked = true;
      }
      return;
    }
    if (attempt < 120) setTimeout(function () { hook(attempt + 1); }, 500);
  }

  function start() {
    refresh();
    hook(0);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refresh();
    });
    setInterval(function () { if (Date.now() > END) render(null); }, 600000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
